import React from 'react';
import {View} from 'react-native';
import {ThemeIcon} from './ThemeIcon';
import {useTokens} from './delivered/theme/tokens';

// Native shapes keep the same optical size and stroke on web, Android and iOS.
export function MapGlyph({name,color}:{name:'satellite'|'sun'|'moon'|'pin';color:string}){
 const {colors}=useTokens();
 const outline={borderWidth:1.7,borderColor:color};
 if(name==='sun'||name==='moon')return <ThemeIcon light={name==='sun'} color={color} background={colors.surface} size={24}/>;
 return <View accessible={false} pointerEvents="none" style={{width:24,height:24}}>
  {name==='pin'?<>
   <View style={[outline,{position:'absolute',left:5,top:2,width:14,height:14,borderRadius:8,borderBottomRightRadius:1,transform:[{rotate:'45deg'}]}]}/>
   <View style={[outline,{position:'absolute',left:9,top:6,width:6,height:6,borderRadius:3}]}/>
  </>:<View style={{width:24,height:24,transform:[{rotate:'-35deg'}]}}>
   <View style={[outline,{position:'absolute',left:9,top:8,width:6,height:9,borderRadius:1.5}]}/>
   {[1,17].map(left=><View key={left} style={[outline,{position:'absolute',left,top:9,width:6,height:7,borderRadius:.5}]}><View style={{position:'absolute',left:1,top:0,bottom:0,width:1.7,backgroundColor:color}}/></View>)}
   <View style={{position:'absolute',left:7,top:11,width:2,height:1.7,backgroundColor:color}}/>
   <View style={{position:'absolute',left:15,top:11,width:2,height:1.7,backgroundColor:color}}/>
   <View style={{position:'absolute',left:11,top:5,width:1.7,height:3,backgroundColor:color}}/>
   <View style={{position:'absolute',left:8,top:1,width:8,height:5,borderWidth:1.7,borderTopWidth:0,borderColor:color,borderBottomLeftRadius:5,borderBottomRightRadius:5}}/>
  </View>}
 </View>;
}
